var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcMail(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 13.014"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_140",
    "data-name": "Group 140",
    transform: "translate(-5311 -1125)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_182",
    d: "M0 0h15.845v10.914H0z",
    className: "cls-1",
    "data-name": "Rectangle 182",
    transform: "translate(5312.1 1126.1)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161",
    d: "M16.958 13.014H.987A1 1 0 0 1 0 12.027V.987A1 1 0 0 1 .987 0h16.061a.983.983 0 0 1 .9.987v11.13a.922.922 0 0 1-.99.897zM1.884 11.13h14.177V1.885H1.884z",
    className: "cls-2",
    "data-name": "Path 161",
    transform: "translate(5311 1125)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_139",
    "data-name": "Group 139",
    transform: "translate(5311.045 1125.045)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_162",
    d: "M8.978 9.5a1.536 1.536 0 0 1-.628-.2L.364 1.9A1.177 1.177 0 0 1 .274.4.906.906 0 0 1 1.62.3l7.358 6.8L16.425.3a.91.91 0 0 1 1.346.1 1.184 1.184 0 0 1-.09 1.5L9.7 9.3a2.543 2.543 0 0 1-.722.2z",
    className: "cls-2",
    "data-name": "Path 162",
    transform: "translate(-.045 -.045)"
  })))));
}
export default __webpack_public_path__ + "static/media/ic_mail.f11d2c7b.svg";
export { SvgIcMail as ReactComponent };